export default __webpack_public_path__ + "static/media/plusBlue.2c5e89eb.svg";